export default __webpack_public_path__ + "static/media/closet5-after3-1920w.491e33a0.avif";